import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getAuthStore = (state: RootState) => state.authStore;
const authorizedUser = createSelector(getAuthStore, (state) => state.authorizedUser);
const tokenExpires = createSelector(getAuthStore, (state) => state.tokenExpires);

export { authorizedUser, tokenExpires };
